import 'arrive';

document.arrive('.block-accordions', { existing: true }, function (el) {
    // Scope all selectors to this specific block instance
    const accordions = el.querySelectorAll('.accordion-item');

    accordions.forEach(item => {
        const collapse = item.querySelector('.accordion-collapse');
        if (!collapse) return;

        // appena inizia ad aprirsi
        collapse.addEventListener('show.bs.collapse', () => {
            item.classList.add('is-open');
        });

        // appena inizia a chiudersi
        collapse.addEventListener('hide.bs.collapse', () => {
            item.classList.remove('is-open');
        });
    });
});